import { useState } from 'react';
import { Button } from '@warp-ds/react';
import usePulse from '../../../hooks/usePulse';
import { OptedInType } from '../../../types/uiTypes';
import BuyerProtectionSvg from './BuyerProtectionSvg';
import OnboardingModal from './OnboardingModal';
import { useSidebarContext } from '../../../state/SidebarContext';

/**
 * A section with text that explains to the buyer about the safety of using ship-it.
 * It includes a modal for more information.
 */
const Onboarding = () => {
    const { shipItInfo }: OptedInType = useSidebarContext().uiText.sections.sidebar.optedIn;
    const { title, text, actions, onboardingModal } = shipItInfo;
    const { trackShowFiksFerdigAllInfo } = usePulse();
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
        trackShowFiksFerdigAllInfo();
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <div className="flex">
            <BuyerProtectionSvg className="shrink-0 mr-8" />
            <div>
                <h2 className="h4 mb-4">{title}</h2>
                <p className="mb-0 text-caption">{text}</p>
                <Button className="py-4 font-bold underline text-caption" link onClick={openModal}>
                    {actions.showOnboarding.text}
                </Button>
            </div>
            <OnboardingModal
                uiText={onboardingModal}
                isOpen={modalIsOpen}
                closeModal={closeModal}
            />
        </div>
    );
};

export default Onboarding;
